import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/Header&Footer/siteconfig.gif";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { GoSignIn } from "react-icons/go";
import { CiLogin } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";

const Header = () => {
  const navigate = useNavigate();

  const [showLogin, setShowLogin] = useState(false);
  const [userImage, setUserImage] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openFertilizer, setOpenFertilizer] = useState(false);
  const [itAutomation, setItAutomation] = useState(false);


  const toggleLoginSection = () => {
    setShowLogin(!showLogin);
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const [isWhiteBackground, setIsWhiteBackground] = useState(true);

  useEffect(() => {
    const backgroundColor = window.getComputedStyle(
      document.body
    ).backgroundColor;

    if (
      backgroundColor === "rgb(255, 255, 255)" ||
      backgroundColor === "white"
    ) {
      setIsWhiteBackground(true);
    } else {
      setIsWhiteBackground(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate("/login");
  };

  useEffect(() => {
    const storedIsAuthenticated =
      localStorage.getItem("isAuthenticated") === "true";
    const storedUserImage = localStorage.getItem("userImage");
    if (storedIsAuthenticated && storedUserImage) {
      setIsAuthenticated(true);
      setUserImage(storedUserImage);
    }
  }, []);

  const [dropdownVisible, setDropdownVisible] = useState({
    about: false,
    products: false,
    services: false,
    support: false,
    contact: false,
  });

  const toggleDropdown = (section) => {
    setDropdownVisible((prevState) =>
      prevState
        ? {
            ...Object.keys(prevState).reduce((acc, key) => {
              acc[key] = key === section ? !prevState[key] : false;
              return acc;
            }, {}),
          }
        : {}
    );
  };

  // Close dropdown when a NavLink is clicked
  const closeDropdown = () => {
    setDropdownVisible({
      about: false,
      products: false,
      services: false,
      support: false,
      contact: false,
    })
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <header
      className={`sticky top-0  w-full  z-50  px-6 py-1 flex justify-between items-center font-poppins transition-all duration-500 ease-in-out ${
        menuOpen || scrolled
          ? "bg-white text-black border-b border-gray-200"
          : "bg-white sm:text-black   sm:border-none"
      }`}
    >
      <div className="flex items-center space-x-2">
        <div className="w-40 mt-1">
          <img src={logo} alt="Site Logo" />
        </div>
      </div>

      <button className="lg:hidden text-3xl  " onClick={toggleMenu}>
        {menuOpen ? <IoMdClose /> : <IoMdMenu />}
      </button>

      <nav
        className={`absolute top-20 right-0 w-full shadow-md lg:static lg:flex lg:space-x-6 lg:shadow-none lg:w-auto transition-all duration-500 ${
          menuOpen ? "block bg-white" : "hidden "
        }`}
      >
        <NavLink to="/" className="hover:text-green-900">
          HOME
        </NavLink>

        <div className="relative group ">
          {/* Main Button */}
          <button
            className="hover:text-green-900  flex justify-between items-center w-full lg:w-auto lg:inline-flex "
            onClick={() => toggleDropdown("about")}
          >
            ABOUT US <IoMdArrowDropdown className="ml-auto lg:ml-1" />
          </button>

          {/* Dropdown for Mobile & Desktop */}
          <div
            className={`absolute md:top-[22px] top-[-20px] left-0 w-full md:w-[180px] bg-white shadow-lg h-36 md:h-auto  text-md md:text-sm rounded-none sm:rounded-md z-10  hover:visible
    transition-all duration-300 ease-in-out ${
      dropdownVisible.about ? "block  opacity-100" : "hidden opacity-0"
    } lg:group-hover:block visible lg:opacity-100`}
          >
            <div className="flex flex-col text-start  ">
              <button
                className="block px-2 py-1 text-black  lg:hidden text-left"
                onClick={() => toggleDropdown("about")}
              >
                Back
              </button>

              <NavLink
                to="/company-profile"
                className="block px-2 py-1 text-black hover:text-green-900 "
                onClick={() => closeDropdown("about")}
              >
                Company Profile
              </NavLink>
              {/* <NavLink
                to="/vision-mission"
                className="block px-2 py-1 text-black hover:text-green-900 "
                onClick={() => closeDropdown("about")}
              >
                Vision & Mission
              </NavLink> */}
              <NavLink
                to="/leadership"
                className="block px-2 py-1 text-black hover:text-green-900 "
                onClick={() => closeDropdown("about")}
              >
                Leadership Team
              </NavLink>
            </div>
          </div>
        </div>

        {/* Dropdown for Products */}
        <div className="relative group">
          {/* Main Button */}
          <button
            className="hover:text-green-900 flex justify-between items-center w-full lg:w-auto lg:inline-flex "
            onClick={() => toggleDropdown("products")}
          >
            PRODUCTS <IoMdArrowDropdown />
          </button>

          {/* Dropdown for Mobile & Desktop */}
          <div
            className={`absolute md:top-[26px] top-[-70px] left-0 w-full md:w-[290px] h-48 md:h-auto bg-white  text-md md:text-sm shadow-lg  rounded-none sm:rounded-md z-10 
    transition-all duration-300 ease-in-out ${
      dropdownVisible.products ? "block opacity-100 " : "hidden opacity-0  "
    }lg:group-hover:block lg:opacity-100`}
          >
            <div className="flex flex-col text-start">
                {/* Back Button for Mobile */}
                <button
                  className="block px-2 py-1 text-black  lg:hidden text-left"
                  onClick={() => toggleDropdown("products")}
                >
                  Back
                </button>

                {/* Dropdown Links */}
                <NavLink
                  to="/synergy-dg"
                  className="block px-4 py-1 hover:text-green-900 text-black font-sans  whitespace-normal break-words"
                  onClick={() => closeDropdown("products")}
                >
                  {" "}   
                  Compressed Bio Gas
                </NavLink>

            <div>
                <NavLink
              to="/synergy-organic-fertilizer"
             className="flex items-center justify-between w-full text-left px-4 py-1 hover:text-green-900 text-black font-sans whitespace-normal break-words"
            onClick={() => setOpenFertilizer(!openFertilizer)}
          >
            <span>Organic Fertilizer</span>
            <IoMdArrowDropdown
              className={`ml-2 transition-transform duration-200 ${
                openFertilizer ? "rotate-180" : "rotate-0"
              }`}
            />
          </NavLink>


          {openFertilizer && (
            <div className="ml-6">
              <NavLink
                to="/synergy-prom"
                className="block px-4 py-1 hover:text-red-900 text-black"
                onClick={() => closeDropdown("products")}
              >
                - PROM
              </NavLink>
              <NavLink
                to="/synergy-fom"
                    className="block px-4 py-1 hover:text-red-900 text-black font-sans  whitespace-normal break-words"
                onClick={() => closeDropdown("products")}
              >
               - FOM
              </NavLink>
              <NavLink
                to="/synergy-lfom"
                    className="block px-4 py-1 hover:text-red-900 text-black font-sans  whitespace-normal break-words"
                onClick={() => closeDropdown("products")}
              >
               - LFOM
              </NavLink>
            
            </div>
          )}
    </div>

              
              

               <div>
                <NavLink
                to="/it-automation"
            className="flex items-center justify-between w-full text-left px-4 py-1 hover:text-green-900 text-black font-sans whitespace-normal break-words"
            onClick={() => setItAutomation(!itAutomation)}
          >
            <span>IT and Automation </span>
            <IoMdArrowDropdown
              className={`ml-2 transition-transform duration-200 ${
                itAutomation ? "rotate-180" : "rotate-0"
              }`}
            />
          </NavLink>


          {itAutomation && (
            <div className="ml-6">
              <NavLink
                to="/synergy-drishti"
                className="block px-4 py-1 hover:text-red-900 text-black"
                onClick={() => closeDropdown("products")}
              >
                - Drishti
              </NavLink>
              {/* <NavLink
                to="/synergy-kawach"
                    className="block px-4 py-1 hover:text-red-900 text-black font-sans  whitespace-normal break-words"
                onClick={() => closeDropdown("products")}
              >
                - Synergy Kawach
              </NavLink> */}
              <NavLink
                to="/synergy-fillnow"
                    className="block px-4 py-1 hover:text-red-900 text-black font-sans  whitespace-normal break-words"
                onClick={() => closeDropdown("products")}
              >
                - Fill Now
              </NavLink>
            
            </div>
          )}
    </div>
             
            
              <NavLink
                to="/synergy-def-dispenser"
                className="block px-4 py-1 hover:text-green-900 text-black font-sans  whitespace-normal break-words"
                onClick={() => closeDropdown("products")}
              >
                DEF Dispenser
              </NavLink>
            </div>
          </div>
        </div>
        {/* Dropdown for Services */}
        <div className="relative group">
          {/* Main Button */}
          <button
            className="hover:text-green-900 flex justify-between font-sans items-center w-full lg:w-auto lg:inline-flex "
            onClick={() => toggleDropdown("services")}
          >
            SERVICES <IoMdArrowDropdown />
          </button>

          {/* Dropdown for Mobile & Desktop */}
          <div
            className={`absolute  text-md md:text-sm  md:top-[22px] top-[-68px] left-0 w-full md:w-[150px] h-36 md:h-auto bg-white shadow-xl rounded-none sm:rounded-md z-10 transition-all duration-300 ease-in-out ${
              dropdownVisible.services
                ? "block opacity-100"
                : "hidden opacity-0"
            } lg:group-hover:block lg:opacity-100`}
          >
            <div className="flex flex-col text-start">
              {/* Back Button for Mobile */}
              <button
                className="block px-2 py-1 text-black  lg:hidden text-left"
                onClick={() => toggleDropdown("services")}
              >
                Back
              </button>

              {/* Dropdown Links */}
              <NavLink
                to="/synergy-fabrication"
                className="hover:text-green-900 flex justify-between font-sans items-center w-full lg:w-auto lg:inline-flex "
                onClick={() => closeDropdown("services")}
              >
                Fabrication Services
              </NavLink>
              
            </div>
          </div>
        </div>
        {/* Dropdown for Support */}
        <div className="relative group">
          {/* Main Button */}
          <button
            className="hover:text-green-900 flex justify-between font-sans items-center w-full lg:w-auto lg:inline-flex "
            onClick={() => toggleDropdown("support")}
          >
            SUPPORT <IoMdArrowDropdown />
          </button>

          {/* Dropdown for Mobile & Desktop */}
          <div
            className={`absolute  text-md md:text-sm  md:top-[22px] top-[-90px] mb-0 left-0 w-full md:w-[130px] h-36 md:h-auto bg-white  sm:rounded-md rounded-none  text-md  z-10 transition-all duration-300 ease-in-out ${
              dropdownVisible.support ? "block opacity-100" : "hidden opacity-0"
            } lg:group-hover:block lg:opacity-100`}
          >
            <div className="flex flex-col text-start">
              {/* Back Button for Mobile */}
              <button
                className="block px-2 py- text-black  lg:hidden text-left"
                onClick={() => toggleDropdown("support")}
              >
                Back
              </button>

              {/* Dropdown Links */}
              <NavLink
                to="/faqs"
                className="block px-2 py-1 hover:text-green-900 text-black font-sans "
                onClick={() => closeDropdown("support")}
              >
                FAQ
              </NavLink>
              {/* <NavLink
                to="/contact-support"
                className="block px-2 py-1 hover:text-green-900 text-black font-sans "
                onClick={() => toggleDropdown("support")}
              >
                Download
              </NavLink> */}
            </div>
          </div>
        </div>

        {/* Dropdown for Contact Us */}
        <div className="relative group ">
          <button
            className="flex justify-between items-center w-full lg:w-auto lg:inline-flex text-md font-sans hover:text-green-900 "
            onClick={() => toggleDropdown("contact")}
          >
            CONTACT US <IoMdArrowDropdown />
          </button>
          <div
            className={`absolute   md:top-[22px] top-[-120px] left-0 w-full md:w-[130px] h-36 md:h-auto   sm:rounded-md rounded-nonesm:rounded-md rounded-none bg-white  text-md  z-10 transition-all duration-300 ease-in-out ${
              dropdownVisible.contact
                ? "block opacity-100 "
                : "hidden opacity-0"
            } lg:group-hover:block lg:opacity-100 `}
          >
            <div className="flex flex-col text-start">
              {/* Back Button for Mobile */}
              <button
                className="block px-2 py-1 ml-3 text-black  lg:hidden text-left"
                onClick={() => toggleDropdown("contact")}
              >
                Back
              </button>

              {/* Dropdown Links */}
              <NavLink
                to="/contact-us"
                className="block px-4 py-1 text-md font-sans text-black hover:text-green-900 "
                onClick={() => closeDropdown("contact")}
              >
                Contact Us
              </NavLink>
              <NavLink
                to="/careers"
                className="block px-4 py-1 text-md font-sans text-black hover:text-green-900 "
                onClick={() => closeDropdown("contact")}
              >
                Careers
              </NavLink>
            </div>
          </div>
        </div>
      </nav>

      {/* Google Search Icon with Bottom Line */}

      <div className="relative hidden lg:block">
        {/* <div onClick={toggleLoginSection} className="cursor-pointer">
          {isAuthenticated && userImage ? (
            <img
              src={userImage}
              alt="User Profile"
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <CgProfile size={30} />
          )}
        </div> */}

        {/* {showLogin && (
          <div className="absolute bottom-[-52px] rounded-lg right-0 bg-gray-600 px-12 py-3 p-4">
            {!isAuthenticated ? (
              <div className="flex items-center">
                <CiLogin size={24} />
                <button className="ml-2 " onClick={handleLoginClick}>
                  Login
                </button>
              </div>
            ) : (
              <div className="flex items-center">
                <GoSignIn size={24} />
                <button className="ml-2 text-white" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        )} */}
      </div>
    </header>
  );
};

export default Header;
